<template>
  <div v-if="modals.length" class="modal-container">
    <div class="modal-backdrop" @click.self="closeTopModal"></div>
    
    <div class="modal-wrapper">
      <component
        v-for="(modal, index) in modals"
        :is="modal.component"
        :key="index"
        v-bind="modal.props"
        @close="closeModal(index)"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    modals() {
      return this.$store.state.globalStore.modals
    }
  },
  methods: {
    closeModal(index) {
      this.$store.commit('closeModal', index)
    },
    closeTopModal() {
      if (this.modals.length) {
        const topModal = this.modals[this.modals.length - 1]
        if (topModal.closeOnBackdrop !== false) {
          this.closeModal(this.modals.length - 1)
        }
      }
    }
  }
}
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>